import http from "@/apps/shared/baseService/config";

const base = {
  rota: "relatorios",
  nome: "Relatórios"
};

export const service = {
  criar: data => http.post(`/admin/${base.rota}/create`, data),
  listar_venda: data =>
    http.post(`/admin/${base.rota}/get-relatorio-venda`, data),
  listar_conta: data =>
    http.post(`/admin/${base.rota}/get-relatorio-conta`, data),
  listar_venda_e_conta: data =>
    http.post(`/admin/${base.rota}/get-relatorio-venda-e-conta`, data),
  listar_venda_cancelada: data =>
    http.post(`/admin/${base.rota}/get-relatorio-venda-cancelada`, data),
  listar_venda_recusada: data =>
    http.post(`/admin/${base.rota}/get-relatorio-venda-recusada`, data),
  atualizar: data => http.post(`/admin/${base.rota}/update`, data),
  excluir: data => http.post(`/admin/${base.rota}/delete`, data),
  excluir_muitos: data => http.post(`/admin/${base.rota}/delete-many`, data)
};

const module = {
  actions: {
    listar_relatorios: ({ dispatch }) => dispatch("listar_relatorios_venda"),
    listar_relatorios_venda: ({ commit, dispatch, getters }) => {
      dispatch("enableLoading");
      service
        .listar_venda(getters.get_relatorios_filtros)
        .then(res => {
          dispatch("disableLoading");
          commit("set_relatorios", res.data);
        })
        .catch(e => {
          dispatch("disableLoading");
          dispatch("createGlobalMessage", {
            type: "error",
            message: e.response.data.message,
            timeout: 6000
          });
        });
    },
    listar_relatorios_conta: ({ commit, dispatch, getters }) => {
      dispatch("enableLoading");
      service
        .listar_conta(getters.get_relatorios_filtros)
        .then(res => {
          dispatch("disableLoading");
          commit("set_relatorios", res.data);
        })
        .catch(e => {
          dispatch("disableLoading");
          dispatch("createGlobalMessage", {
            type: "error",
            message: e.response.data.message,
            timeout: 6000
          });
        });
    },
    atualizar_relatorio: ({ commit, dispatch, getters }) => {
      // dispatch("enableLoading");
      service
        // .atualizar({ ...getters.get_relatorio, imagens: getters.getLinks })
        .atualizar({ ...getters.get_relatorio })
        .then(res => {
          dispatch("disableLoading");
          commit("set_relatorio", res.data);
          dispatch("createGlobalMessage", {
            type: "success",
            message: "Atualização Concluída!",
            timeout: 6000
          });
          // dispatch("listar_relatorios");
        })
        .catch(e => {
          dispatch("disableLoading");
          dispatch("createGlobalMessage", {
            type: "error",
            message: e.response.data.message,
            timeout: 6000
          });
        });
    },
    criar_relatorio: ({ commit, dispatch, getters }) => {
      dispatch("enableLoading");
      service
        .criar({ ...getters.get_relatorio, imagens: getters.getLinks })
        .then(() => {
          dispatch("disableLoading");
          commit("set_relatorio", {});
          commit("setLinks", []);
          dispatch("createGlobalMessage", {
            type: "success",
            message: "Registro Concluído!",
            timeout: 6000
          });
          dispatch("listar_relatorios");
          dispatch("listar_relatoriocategorias");
          commit("set_modal_view_relatorio", false);
        })
        .catch(e => {
          dispatch("disableLoading");
          dispatch("createGlobalMessage", {
            type: "error",
            message: e.response.data.message,
            timeout: 6000
          });
        });
    },
    excluir_relatorio: ({ dispatch, getters }) => {
      dispatch("enableLoading");
      service
        .excluir(getters.get_relatorio)
        .then(() => {
          dispatch("disableLoading");
          dispatch("createGlobalMessage", {
            type: "success",
            message: "Exclusão Concluída!",
            timeout: 6000
          });
          dispatch("listar_relatorios");
        })
        .catch(e => {
          dispatch("disableLoading");
          dispatch("createGlobalMessage", {
            type: "error",
            message: e.response.data.message,
            timeout: 6000
          });
        });
    },
    excluir_relatorios: ({ dispatch, getters }) => {
      dispatch("enableLoading");
      service
        .excluir(getters.get_relatorios_marcados)
        .then(() => {
          dispatch("disableLoading");
          dispatch("createGlobalMessage", {
            type: "success",
            message: "Exclusão em massa Concluída!",
            timeout: 6000
          });
          dispatch("listar_relatorios");
        })
        .catch(e => {
          dispatch("disableLoading");
          dispatch("createGlobalMessage", {
            type: "error",
            message: e.response.data.message,
            timeout: 6000
          });
        });
    },
    abre_modal_view_relatorio: ({ commit, getters, dispatch }, payload) => {
      if (payload) {
        commit("set_relatorio", payload);
        commit("setLinks", payload.imagens);
      }
      commit("set_modal_view_relatorio", true);
    },
    fecha_modal_view_relatorio: ({ commit }) => {
      commit("set_relatorio", {});
      commit("setLinks", []);
      commit("set_modal_view_relatorio", false);
    },
    add_relatorio_marcado: ({ commit, getters }, payload) => {
      commit("set_relatorios_marcados", [
        ...getters.get_relatorios_marcados,
        payload
      ]);
    },
    remove_relatorio_marcado: ({ commit, getters }, i) => {
      commit(
        "set_relatorios_marcados",
        ...getters.get_relatorios_marcados.filter((item, index) => index !== i)
      );
    }
  },
  state: {
    relatorio: {},
    relatorios: {
      docs: []
    },
    relatorios_marcados: [],
    relatorios_filtros: {
      limitPerPage: 10,
      page: 1,
      dataInicio: "",
      dataFim: ""
    },
    modal_view_relatorio: false
  },
  mutations: {
    set_relatorio: (state, payload) => (state.relatorio = payload),
    set_relatorios: (state, payload) => {
      state.relatorios = payload;
      state.relatorios_filtros.totalPages = payload.totalPages || 1;
      state.relatorios_filtros.page = payload.page || state.relatorios_filtros.page || 1;
    },
    set_relatorios_marcados: (state, payload) =>
      (state.relatorios_marcados = payload),
    set_modal_view_relatorio: (state, payload) =>
      (state.modal_view_relatorio = payload)
  },
  getters: {
    get_relatorio: state => state.relatorio,
    get_relatorios: state => state.relatorios,
    get_relatorios_marcados: state => state.relatorios_marcados,
    get_modal_view_relatorio: state => state.modal_view_relatorio,
    get_relatorios_filtros: state => state.relatorios_filtros
  }
};

const routes = [
  {
    path: `/${base.rota}`,
    component: () => import("./views/Listar.vue"),
    name: base.nome
  }
];

export default {
  service,
  module,
  routes
};
